import { render, staticRenderFns } from "./ComponentWrap.vue?vue&type=template&id=c5022f84&scoped=true"
import script from "./ComponentWrap.vue?vue&type=script&lang=js"
export * from "./ComponentWrap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5022f84",
  null
  
)

export default component.exports